<template>
  <figure
    class="rounded-full transition-shadow duration-300 hover:elevation-1 hover:transition-shadow hover:duration-300 bg-white"
  >
    <!-- User image -->
    <img
      :src="src ? src : '/images/profile-placeholder.jpg'"
      :alt="alt"
      :class="{
        'object-cover rounded-full': true,
        'border-2 border-solid border-outline': withBorder && size !== 'extra-small',
        'border border-solid border-outline': withBorder && size === 'extra-small',
        'min-w-[32px] w-[32px] min-h-[32px] h-[32px]': size === 'extra-small',
        'min-w-[40px] w-[40px] min-h-[40px] h-[40px]': size === 'small',
        'min-w-[80px] w-[80px] min-h-[80px] h-[80px]': size === 'medium',
        'min-w-[160px] w-[160px] min-h-[160px] h-[160px]': size === 'large',
        'w-full h-auto': size === 'auto',
      }"
    />
  </figure>
</template>

<script>
export default {
  name: 'ProfilePicture',
  props: {
    src: String,
    withBorder: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'auto',
      validator(value) {
        return ['extra-small', 'small', 'medium', 'large', 'auto'].includes(value)
      },
    },
    alt: {
      type: String,
    },
  },
}
</script>

<style></style>
